import { QuestionCircleFilled } from "@ant-design/icons";
import Img from "assets/images";

import { LOYALTY_MODAL_ICON } from "./constants";

function LoyaltyModalIconHeader({ iconType = LOYALTY_MODAL_ICON.QUESTION }) {
  const isDelete = iconType === LOYALTY_MODAL_ICON.DELETE;

  return (
    <div className="loyalty-modal-icon-header">
      {isDelete ? (
        <div
          className="loyalty-modal-icon-header__icon--delete"
          style={{ backgroundImage: `url(${Img.DeleteIcon})` }}
          aria-hidden
        />
      ) : (
        <QuestionCircleFilled className="loyalty-modal-icon-header__icon--question" />
      )}
    </div>
  );
}

export default LoyaltyModalIconHeader;
